import { keyBy } from "lodash";
import { ComponentType } from "react";
import PageNotFound from "./pages/404";
import AuthCallback from "./pages/auth/callback";
import ChangeLog from "./pages/change-log";
import DataBrowser from "./pages/data-browser";
import FAQPage from "./pages/faq";
import Home from "./pages/home";
import ListBuilderForm from "./pages/list-builder-form";
import ListBuilder from "./pages/list-builder-table";
import ListPage from "./pages/list-page";
import TrackedList from "./pages/tracked-lists";
import UserPreferences from "./pages/user-preferences";

interface IRoute {
    path: string;
    component: ComponentType;
    isPublic?: boolean;
    label: string;
}

export const routes: Array<IRoute> = [
    { path: "/", component: Home, label: "home" },
    {
        path: "/auth/callback",
        component: AuthCallback,
        isPublic: true,
        label: "authCallback",
    },
    { path: "/list-builder", component: ListBuilder, label: "listBuilder" },
    {
        path: "/create-list-builder",
        component: ListBuilderForm,
        label: "createListBuilder",
    },
    {
        path: "/list-builder/:listBuilderId",
        component: ListBuilderForm,
        label: "editListBuilder",
    },
    { path: "/data-browser", component: DataBrowser, label: "dataBrowser" },
    {
        path: "/user-preferences",
        component: UserPreferences,
        label: "userPreferences",
    },
    { path: "/tracked-lists", component: TrackedList, label: "trackedLists" },
    { path: "/change-log", component: ChangeLog, label: "changeLog" },
    { path: "/faq", component: FAQPage, label: "faq" },
    { path: "/list/:listId", component: ListPage, label: "searchList" },
    { path: "*", component: PageNotFound, label: "notFound" },
];

export const routeMapping = keyBy(routes, "label");
